import { StyleSheet, Text, View } from "@react-pdf/renderer";
import React, { useContext } from "react";
import tools from "../../../helpers/tools";
import useCERData from "../../Hooks/useCERData/useCERData";
import { StepContext } from "./StepContext";

const InfoLabel = ({ children }) => {
  var styles = StyleSheet.create({
    info: {
      fontSize: 8,
      color: "#797979",
      paddingLeft: 10,
    },
  });

  return <Text style={{ ...styles.info }}>{children}</Text>;
};

const OperatorsList = () => {
  const { operators } = useCERData();
  const step = useContext(StepContext);

  var styles = StyleSheet.create({
    container: {
      paddingLeft: 10,
      paddingBottom: 4,
    },
    title: {
      fontSize: 9,
      fontWeight: "bold",
      color: "#000000",
    },
  });

  return step.operators.map((operator) => {
    var operatorRef = operators.find((o) => o.id == operator.operator);

    return (
      <View style={{ ...styles.container }}>
        <Text style={{ ...styles.title }}>{operatorRef?.nom}</Text>
        {operatorRef?.adresse ? (
          <InfoLabel>
            {operatorRef.adresse} {operatorRef.codePostal} {operatorRef.ville}
          </InfoLabel>
        ) : null}

        {operatorRef?.email ? (
          <InfoLabel>
            {operatorRef?.telephone ? tools.formatPhone(operatorRef.telephone) : null} -{" "}
            {operatorRef.email}
          </InfoLabel>
        ) : null}
        {operatorRef?.lien ? <InfoLabel>{operatorRef.lien}</InfoLabel> : null}
      </View>
    );
  });
};

export default OperatorsList;
